import type { PiiType } from "@/lib/pii";

/**
 * UI metadata for the PII review dialog (LAR-142): Danish type labels and the
 * legend/badge color classes. Colors come from the tenant-independent `--pii-*`
 * palette defined in `globals.css` (semantic tokens, not hardcoded Tailwind
 * palette classes). Class strings are written as complete literals so the
 * Tailwind v4 scanner emits them.
 */

export const PII_TYPE_LABELS: Record<PiiType, string> = {
  cpr: "CPR-nummer",
  phone: "Telefonnummer",
  email: "E-mailadresse",
  account: "Kontonummer",
  address: "Adresse",
  name: "Navn",
  org: "Organisation",
  custom: "Andet",
};

/** Solid dot color for the legend. */
export const PII_TYPE_DOT_CLASS: Record<PiiType, string> = {
  cpr: "bg-pii-cpr",
  phone: "bg-pii-phone",
  email: "bg-pii-email",
  account: "bg-pii-account",
  address: "bg-pii-address",
  name: "bg-pii-name",
  org: "bg-pii-org",
  custom: "bg-pii-custom",
};

/** Colored left-border + tint for a finding row / inline highlight. */
export const PII_TYPE_BADGE_CLASS: Record<PiiType, string> = {
  cpr: "border-pii-cpr bg-pii-cpr/10",
  phone: "border-pii-phone bg-pii-phone/10",
  email: "border-pii-email bg-pii-email/10",
  account: "border-pii-account bg-pii-account/10",
  address: "border-pii-address bg-pii-address/10",
  name: "border-pii-name bg-pii-name/10",
  org: "border-pii-org bg-pii-org/10",
  custom: "border-pii-custom bg-pii-custom/10",
};
